export enum FormType {
	TextInput = 'TextInput',
	Multiselect = 'Multiselect',
	Select = 'Select',
	Checkbox = 'Checkbox',
}
